import { Box, Drawer, List, ListItem, ListItemIcon, ListItemText, Typography, useMediaQuery, Divider, IconButton, useTheme, Fab, Collapse, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import GradingIcon from '@mui/icons-material/Grading';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import PaidIcon from '@mui/icons-material/Paid';
import axios from 'axios';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import NextWeekIcon from '@mui/icons-material/NextWeek';
import SystemSecurityUpdateGoodIcon from '@mui/icons-material/SystemSecurityUpdateGood';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SummarizeIcon from '@mui/icons-material/Summarize';
import TableRowsIcon from '@mui/icons-material/TableRows';
import SecurityIcon from '@mui/icons-material/Security';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import CropFreeIcon from '@mui/icons-material/CropFree';
import AirportShuttleIcon from '@mui/icons-material/AirportShuttle';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import BadgeIcon from '@mui/icons-material/Badge';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

import QrCodeIcon from '@mui/icons-material/QrCode';
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CloseIcon from '@mui/icons-material/Close';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import logo from '../Logo04small-retocado-teal.png';
import palette from '../theme/palette';
import SunatMenuIcon from '../assets/images/sunat0.png';
import useMenuRuntimePermissions from './Admin/menu/useMenuRuntimePermissions';
import useProductoGruposHabilitado from './Admin/producto/useProductoGruposHabilitado';

const drawerWidthExpanded = 240;
const drawerWidthCollapsed = 80;
// El lateral usa los tokens menu*, derivados del acento del tema (ver
// theme/palette.js): fondo con el acento oscurecido y texto aclarado. Antes el
// hover y el activo se pintaban del mismo color que el fondo y no se veian.
const sidebarColors = {
  bg: palette.menuBg,
  surface: palette.menuBg,
  surfaceSoft: palette.menuBg,
  border: palette.menuBg,
  text: palette.menuText,
  muted: palette.menuMuted,
  accent: palette.menuText,
  accentSoft: palette.menuActive,
  overlaySoft: palette.menuHover,
  danger: palette.danger,
  onAccent: palette.menuBg,
  shadowSoft: palette.shadowSoft,
};

const operationalIconTones = {
  encomiendas: {
    color: '#8fa6bd',
    soft: 'rgba(143,166,189,0.14)',
    border: 'rgba(143,166,189,0.38)',
  },
  entregas: {
    color: '#79ab8f',
    soft: 'rgba(121,171,143,0.14)',
    border: 'rgba(121,171,143,0.38)',
  },
  caja: {
    color: '#bda269',
    soft: 'rgba(189,162,105,0.14)',
    border: 'rgba(189,162,105,0.38)',
  },
};

// Icono de minivan con lineas de velocidad, usado para el acceso de Boletos.
const MinivanMenuIcon = () => (
  <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center', lineHeight: 0 }}>
    <Box
      component="span"
      sx={{
        position: 'absolute',
        left: -9,
        top: 5,
        width: 10,
        height: 2,
        borderRadius: 2,
        backgroundColor: 'currentColor',
        opacity: 0.62,
      }}
    />
    <Box
      component="span"
      sx={{
        position: 'absolute',
        left: -14,
        top: 11,
        width: 14,
        height: 2,
        borderRadius: 2,
        backgroundColor: 'currentColor',
        opacity: 0.72,
      }}
    />
    <Box
      component="span"
      sx={{
        position: 'absolute',
        left: -7,
        top: 17,
        width: 8,
        height: 2,
        borderRadius: 2,
        backgroundColor: 'currentColor',
        opacity: 0.48,
      }}
    />
    <AirportShuttleIcon sx={{ transform: 'skewX(-8deg) translateX(2px)' }} />
  </Box>
);

const GremDocumentIcon = () => (
  <Box
    sx={{
      position: 'relative',
      width: '1em',
      height: '1.18em',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      lineHeight: 0,
      transform: 'rotate(-3deg)',
    }}
  >
    <Box
      component="span"
      sx={{
        position: 'absolute',
        inset: '0.06em 0.13em 0.02em 0.08em',
        border: '0.11em solid currentColor',
        borderRadius: '0.16em',
        backgroundColor: 'rgba(255,255,255,0.04)',
      }}
    />
    <Box
      component="span"
      sx={{
        position: 'absolute',
        top: '0.06em',
        right: '0.13em',
        width: '0.34em',
        height: '0.34em',
        borderLeft: '0.11em solid currentColor',
        borderBottom: '0.11em solid currentColor',
        borderBottomLeftRadius: '0.08em',
        backgroundColor: 'rgba(255,255,255,0.08)',
      }}
    />
    {[0.38, 0.58, 0.78].map((top, index) => (
      <Box
        key={top}
        component="span"
        sx={{
          position: 'absolute',
          left: '0.28em',
          top: `${top}em`,
          width: index === 1 ? '0.52em' : '0.42em',
          height: '0.08em',
          borderRadius: 2,
          backgroundColor: 'currentColor',
          opacity: index === 1 ? 0.82 : 0.58,
        }}
      />
    ))}
    <Box
      component="span"
      sx={{
        position: 'absolute',
        right: '-0.02em',
        bottom: '0.03em',
        width: '0.28em',
        height: '0.28em',
        borderRadius: '50%',
        backgroundColor: 'currentColor',
        opacity: 0.28,
      }}
    />
  </Box>
);

// Fuente personalizada para todo el Sidebar
//const sidebarFont = 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
const sidebarFont = 'var(--app-font-sans)';
//const sidebarFont = 'IBM Plex Sans, sans-serif';

export default function NavSideBar(props) {
  const back_host = process.env.BACK_HOST || "https://xpertcont-backend-js-production-50e6.up.railway.app";  
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [selectedButton, setSelectedButton] = useState(null);
  const [isExpanded, setIsExpanded] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const panoramicMode = Boolean(props.panoramicMode);
  
  const { user, isAuthenticated } = useAuth0();
  const [permisos, setPermisos] = useState([]);

  const [permisoVentas, setPermisoVentas] = useState(false);
  const [permisoCompras, setPermisoCompras] = useState(false);
  const [permisoCaja, setPermisoCaja] = useState(false);
  const [permisoDiario, setPermisoDiario] = useState(false);
  const [permisoReportes, setPermisoReportes] = useState(false);
  
  const [accesoAdmin, setAccesoAdmin] = useState(false);
  const [accesoCont, setAccesoCont] = useState(false);

  const [permisoContabilidades, setPermisoContabilidades] = useState(false);
  const [permisoTipoCambio, setPermisoTipoCambio] = useState(false);
  const [permisoCorrentista, setPermisoCorrentista] = useState(false);
  const [permisoCentroCosto, setPermisoCentroCosto] = useState(false);
  const [permisoSeguridad, setPermisoSeguridad] = useState(false);

  const [periodo_trabajo, setPeriodoTrabajo] = useState("");
  const [periodo_select, setPeriodosSelect] = useState([]);

  const [contabilidad_trabajo, setContabilidadTrabajo] = useState("");
  const [contabilidad_select, setContabilidadesSelect] = useState([]);
  
  const [openStocks, setOpenStocks] = useState(false);
  const [openVentas, setOpenVentas] = useState(false);
  const [openTransportes, setOpenTransportes] = useState(false);
  const [openSire, setOpenSire] = useState(false);
  const [openContable, setOpenContable] = useState(false);
  
  const handleClick = (buttonId) => {
    setSelectedButton(buttonId);
    if (isMobile) {
      setMobileOpen(false);
    }
  }

  const toggleDrawer = () => {
    if (!isMobile && typeof props.onTogglePanoramic === "function") {
      setIsExpanded(true);
      props.onTogglePanoramic();
      return;
    }
    if (isMobile) {
      setMobileOpen(!mobileOpen);
    } else {
      setIsExpanded(!isExpanded);
    }
  }

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleStocksClick = () => {
    setOpenStocks(!openStocks);
  };

  const handleVentasClick = () => {
    setOpenVentas(!openVentas);
  };

  const handleTransportesClick = () => {
    setOpenTransportes(!openTransportes);
  };

  const handleContableClick = () => {
    setOpenContable(!openContable);
  };

  useEffect(() => {
    if (isAuthenticated && user && user.email) {
      cargaModulosAnfitrion();
      cargaPermisosMenu();
      console.log("idAnfitrion: ", props.idAnfitrion);
      console.log("idInvitado: ", props.idInvitado);
      cargaPeriodosAnfitrion();
      cargaContabilidadesAnfitrion();
    }
  }, [isAuthenticated, user]);

  const cargaModulosAnfitrion = () => {
    axios
      .get(`${back_host}/usuario/modulos/${props.idAnfitrion}/${props.idInvitado}`)
      .then((response) => {
        if (response.data.length > 0) {
          if (!accesoAdmin) {
            setAccesoAdmin(response.data.some(item => item.tipo === 'ADMIN'));
          }
          if (!accesoCont) {
            setAccesoCont(response.data.some(item => item.tipo === 'CONT'));
          }
          console.log('modulos: ', response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const cargaPeriodosAnfitrion = () => {
    axios
      .get(`${back_host}/usuario/periodos/${props.idAnfitrion}`)
      .then((response) => {
        setPeriodosSelect(response.data);
        if (response.data.length > 0) {
          setPeriodoTrabajo(response.data[0].periodo);
          console.log('setPeriodoTrabajo: ', response.data[0].periodo);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const cargaContabilidadesAnfitrion = () => {
    axios
      .get(`${back_host}/usuario/contabilidades/${props.idAnfitrion}/${props.idInvitado}`)
      .then((response) => {
        setContabilidadesSelect(response.data);
        if (response.data.length > 0) {
          setContabilidadTrabajo(response.data[0].documento_id);
          console.log('setContabilidadTrabajo: ', response.data[0].documento_id);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const cargaPermisosMenu = async () => {
    if (props.idAnfitrion === props.idInvitado) {
      setAccesoCont(true);
      setAccesoAdmin(true);
      setPermisoVentas(true);
      setPermisoCompras(true);
      setPermisoCaja(true);
      setPermisoDiario(true);
      setPermisoReportes(true);
      setPermisoContabilidades(true);
      setPermisoTipoCambio(true);
      setPermisoCorrentista(true);
      setPermisoCentroCosto(true);
      setPermisoSeguridad(true);
    } else {
      fetch(`${back_host}/seguridadmenu/${props.idAnfitrion}/${props.idInvitado}`, {
        method: 'GET',
      })
        .then(response => response.json())
        .then(permisosData => {
          setPermisos(permisosData);
          let tienePermiso;
          tienePermiso = permisosData.some(permiso => permiso.id_menu === '01');
          if (tienePermiso) setPermisoVentas(true);
          tienePermiso = permisosData.some(permiso => permiso.id_menu === '02');
          if (tienePermiso) setPermisoCompras(true);
          tienePermiso = permisosData.some(permiso => permiso.id_menu === '03');
          if (tienePermiso) setPermisoCaja(true);
          tienePermiso = permisosData.some(permiso => permiso.id_menu === '04');
          if (tienePermiso) setPermisoDiario(true);
          tienePermiso = permisosData.some(permiso => permiso.id_menu === '05');
          if (tienePermiso) setPermisoReportes(true);
          tienePermiso = permisosData.some(permiso => permiso.id_menu === '06');
          if (tienePermiso) setPermisoContabilidades(true);
          tienePermiso = permisosData.some(permiso => permiso.id_menu === '07');
          if (tienePermiso) setPermisoTipoCambio(true);
          tienePermiso = permisosData.some(permiso => permiso.id_menu === '08');
          if (tienePermiso) setPermisoCorrentista(true);
          tienePermiso = permisosData.some(permiso => permiso.id_menu === '09');
          if (tienePermiso) setPermisoCentroCosto(true);
          tienePermiso = permisosData.some(permiso => permiso.id_menu === '10');
          if (tienePermiso) setPermisoSeguridad(true);
        })
        .catch(error => {
          console.log('Error al obtener los permisos:', error);
        });
    }
  }

  const itemLabelVisible = isMobile || (isExpanded && !panoramicMode);
  const menuIconSize = itemLabelVisible ? 20 : 25;
  const submenuIconSize = itemLabelVisible ? 16 : 21;
  const renderSunatMenuIcon = (active = false) => (
    <Box
      component="img"
      src={SunatMenuIcon}
      alt=""
      sx={{
        width: submenuIconSize + 2,
        height: submenuIconSize + 2,
        objectFit: 'contain',
        opacity: active ? 1 : 0.9,
        filter: active ? `drop-shadow(0 0 5px ${sidebarColors.accentSoft})` : 'none',
      }}
    />
  );
  const rubroTrabajo = String(props.rubro || sessionStorage.getItem('rubro_trabajo') || 'COMERCIAL').trim().toUpperCase();
  const esRubroTransporte = rubroTrabajo === 'TRANSPORTE' || rubroTrabajo === 'TRANSPORTES';
  const esRubroProyectos = rubroTrabajo === 'PROYECTO' || rubroTrabajo === 'PROYECTOS';
  const esRubroContable = rubroTrabajo === 'CONTABLE' || rubroTrabajo === 'CONTABILIDAD';
  const esRubroComercial = !esRubroTransporte && !esRubroProyectos && !esRubroContable;
  // Grupos Color: el menú aporta rubro/acceso; el hook consulta SKU por empresa.
  // Esta condición solo controla visibilidad; el nuevo backend valida el acceso.
  const gruposSkuHabilitados = useProductoGruposHabilitado(back_host, props.idAnfitrion, contabilidad_trabajo, accesoAdmin && rubroTrabajo === 'COMERCIAL');
  const puedeConfigurarMenus = props.idAnfitrion === props.idInvitado || props.super === true || String(props.super) === '1';
  const permisosTransporte = useMenuRuntimePermissions({
    backHost: back_host,
    idAnfitrion: props.idAnfitrion,
    idInvitado: props.idInvitado,
    rubro: 'TRANSPORTE',
    enabled: esRubroTransporte,
  });
  const puedeMenuTransporte = permisosTransporte.puedeItem;
  const etiquetaPuntosVenta = esRubroTransporte ? 'Agencias' : 'Puntos venta';
  const subtituloRubro = esRubroTransporte
    ? 'Gestion transportes'
    : esRubroProyectos
      ? 'Gestion proyectos'
      : esRubroContable
        ? 'Gestion contable'
        : 'Gestion comercial';
  const tieneOpcionesContables = (
    permisoVentas ||
    permisoCompras ||
    permisoCaja ||
    permisoDiario ||
    permisoReportes ||
    permisoContabilidades ||
    permisoTipoCambio ||
    permisoCentroCosto
  );

  const MenuItem = ({ icon, label, isActive, onClick, badge, hasSubmenu, isSubmenuOpen, menuId }) => {
    const item = (
      <ListItem
        button
        data-menu-id={menuId}
        onClick={onClick}
        sx={{
          position: 'relative',
          overflow: 'hidden',
          minHeight: isMobile ? 48 : 36,
          paddingY: isMobile ? 0.9 : 0.25,
          paddingLeft: itemLabelVisible ? 1.1 : 0,
          paddingRight: itemLabelVisible ? 1 : 0,
          justifyContent: itemLabelVisible ? 'flex-start' : 'center',
          backgroundColor: isActive ? sidebarColors.accentSoft : 'transparent',
          color: sidebarColors.text,
          '&:before': {
            content: 'none',
          },
          '&:after': {
            content: '""',
            position: 'absolute',
            inset: 0,
            pointerEvents: 'none',
            borderTop: '1px solid transparent',
            borderBottom: '1px solid transparent',
          },
          '&:hover': {
            color: sidebarColors.text,
            backgroundColor: isActive ? sidebarColors.accentSoft : sidebarColors.overlaySoft,
          },
          borderRadius: '10px',
          marginY: 0.04,
          marginX: itemLabelVisible ? 0.75 : 1,
          transition: 'background-color .18s ease, color .18s ease, box-shadow .18s ease',
        }}
      >
        <ListItemIcon
          sx={{
            minWidth: itemLabelVisible ? 30 : 0,
            color: isActive ? sidebarColors.accent : sidebarColors.muted,
            justifyContent: 'center',
            '& svg': { fontSize: menuIconSize },
          }}
        >
          {badge && (
            <Box sx={{ position: 'relative', display: 'flex' }}>
              {icon}
              <Typography
                variant="caption"
                sx={{
                  position: 'absolute',
                  top: -9,
                  right: -9,
                  px: 0.45,
                  minWidth: 15,
                  height: 15,
                  borderRadius: 8,
                  backgroundColor: sidebarColors.accent,
                  color: sidebarColors.onAccent,
                  fontSize: '0.58rem',
                  fontWeight: 800,
                  fontFamily: sidebarFont,
                  lineHeight: '15px',
                  textAlign: 'center',
                }}
              >
                {badge}
              </Typography>
            </Box>
          )}
          {!badge && icon}
        </ListItemIcon>
        {itemLabelVisible && (
          <>
            <ListItemText
              primary={label}
              primaryTypographyProps={{
                fontFamily: sidebarFont,
                fontSize: '0.78rem',
                fontWeight: 200,
                fontVariationSettings: '"wght" 200',
                color: isActive ? sidebarColors.text : sidebarColors.muted,
              }}
            />
            {hasSubmenu && (isSubmenuOpen ? <ExpandLess sx={{ color: sidebarColors.muted }} /> : <ExpandMore sx={{ color: sidebarColors.muted }} />)}
          </>
        )}
      </ListItem>
    );

    return itemLabelVisible ? item : (
      <Tooltip title={label} placement="right" arrow>
        {item}
      </Tooltip>
    );
  };

  const SubMenuItem = ({ icon, label, isActive, onClick, watermarkIcon = null, iconTone = null, menuId }) => {
    const tone = iconTone ? operationalIconTones[iconTone] : null;
    const compactTone = Boolean(tone && !itemLabelVisible);
    const compactToneActive = Boolean(compactTone && isActive);
    const iconColor = isActive
      ? (tone?.color || sidebarColors.accent)
      : (compactTone ? tone.color : sidebarColors.muted);
    const iconGlow = compactToneActive ? `drop-shadow(0 0 5px ${tone.soft})` : 'none';
    const toneShadow = compactToneActive
      ? `inset 0 0 0 1px ${tone.border}, 0 0 10px ${tone.soft}`
      : 'none';

    const item = (
      <ListItem
        button
        data-menu-id={menuId}
        onClick={onClick}
        sx={{
          position: 'relative',
          overflow: 'hidden',
          minHeight: isMobile ? 42 : 30,
          paddingY: isMobile ? 0.75 : 0.18,
          paddingLeft: itemLabelVisible ? 3.75 : 0,
          paddingRight: itemLabelVisible ? 1 : 0,
          justifyContent: itemLabelVisible ? 'flex-start' : 'center',
          backgroundColor: isActive
            ? (compactTone ? tone.soft : sidebarColors.accentSoft)
            : 'transparent',
          borderRight: 'none',
          boxShadow: toneShadow,
          '&:hover': {
            color: sidebarColors.text,
            backgroundColor: isActive
              ? (compactTone ? tone.soft : sidebarColors.accentSoft)
              : (compactTone ? 'transparent' : sidebarColors.overlaySoft),
            boxShadow: toneShadow,
          },
          borderRadius: '9px',
          marginY: 0.03,
          marginX: itemLabelVisible ? 0.75 : 1,
        }}
      >
        {itemLabelVisible && watermarkIcon && (
          <Box
            sx={{
              position: 'absolute',
              right: 12,
              top: '50%',
              transform: 'translateY(-50%)',
              color: isActive ? sidebarColors.accentSoft : sidebarColors.overlaySoft,
              pointerEvents: 'none',
              lineHeight: 0,
              '& svg': { fontSize: 28 },
            }}
          >
            {watermarkIcon}
          </Box>
        )}
        <ListItemIcon
          sx={{
            minWidth: itemLabelVisible ? 28 : 0,
            color: iconColor,
            justifyContent: 'center',
            '& svg': {
              fontSize: submenuIconSize,
              filter: iconGlow,
            },
          }}
        >
          {icon}
        </ListItemIcon>
        {itemLabelVisible && (
          <ListItemText
            primary={label}
            primaryTypographyProps={{
              fontFamily: sidebarFont,
              fontSize: '0.72rem',
              fontWeight: 200,
              fontVariationSettings: '"wght" 200',
              color: isActive ? sidebarColors.text : sidebarColors.muted,
            }}
          />
        )}
      </ListItem>
    );

    return itemLabelVisible ? item : (
      <Tooltip title={label} placement="right" arrow>
        {item}
      </Tooltip>
    );
  };

  const drawerContent = (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: sidebarColors.bg,
        background: sidebarColors.bg,
        borderRight: 'none',
        boxShadow: 'none',
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: itemLabelVisible ? 'row' : 'column',
          alignItems: 'center',
          justifyContent: itemLabelVisible ? 'space-between' : 'center',
          gap: itemLabelVisible ? 0 : 0.5,
          px: itemLabelVisible ? 1.75 : 0.75,
          py: itemLabelVisible ? 1.35 : 1,
          minHeight: itemLabelVisible ? 66 : 78,
          position: 'relative',
          backgroundColor: sidebarColors.bg,
          background: sidebarColors.bg,
          borderBottom: 'none',
        }}
      >
        {itemLabelVisible ? (
          <Box sx={{ minWidth: 0, width: '100%', display: 'grid', justifyItems: 'center' }}>
            <Box
              component="img"
              src={logo}
              alt="XpertCont"
              sx={{
                display: 'block',
                width: 104,
                maxWidth: '100%',
                height: 'auto',
                objectFit: 'contain',
              }}
            />
            <Typography sx={{ color: sidebarColors.muted, fontWeight: 200, fontVariationSettings: '"wght" 200', fontSize: '.66rem', mt: 0.35, fontFamily: sidebarFont, textAlign: 'center' }}>
              {subtituloRubro}
            </Typography>
          </Box>
        ) : (
          <Box
            component="img"
            src={logo}
            alt="XpertCont"
            sx={{
              width: 40,
              height: 'auto',
              objectFit: 'contain',
            }}
          />
        )}
        <IconButton
          onClick={toggleDrawer}
          size="small"
          sx={{
            position: itemLabelVisible ? 'absolute' : 'static',
            right: itemLabelVisible ? 8 : 'auto',
            top: itemLabelVisible ? 12 : 'auto',
            color: itemLabelVisible ? sidebarColors.muted : sidebarColors.onAccent,
            backgroundColor: itemLabelVisible ? 'transparent' : sidebarColors.accent,
            '&:hover': {
              color: itemLabelVisible ? sidebarColors.text : sidebarColors.onAccent,
              backgroundColor: itemLabelVisible ? sidebarColors.surfaceSoft : sidebarColors.accent,
            },
          }}
        >
          {isMobile ? <CloseIcon /> : itemLabelVisible ? <ArrowBackIosIcon sx={{ fontSize: 18 }} /> : <MenuIcon sx={{ fontSize: 22 }} />}
        </IconButton>
      </Box>

      <Divider sx={{ borderColor: 'transparent' }} />

      {/* Lista de menú */}
      <List sx={{ 
        flexGrow: 1, 
        paddingTop: 0.35, 
        paddingBottom: 0.75,
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          width: '0px',
        },
        '&::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          background: 'transparent',
        },
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
      }}>
        <MenuItem
          icon={<HomeIcon />}
          label="Inicio"
          isActive={selectedButton === 'icono01'}
          onClick={() => {
            navigate(`/${props.idAnfitrion}/${props.idInvitado}`);
            handleClick('icono01');
          }}
        />

        {accesoAdmin && esRubroComercial && (
          <>
            <MenuItem
              icon={<ShoppingCartIcon />}
              label="Ventas"
              //isActive={selectedButton === 'icono02'}
              onClick={handleVentasClick}
              hasSubmenu={true}
              isSubmenuOpen={openVentas}
            />
            <Collapse in={openVentas} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <SubMenuItem
                  icon={<CropFreeIcon />}
                  label="Registros"
                  iconTone="encomiendas"
                  isActive={selectedButton === 'icono02-1'}
                  onClick={() => {
                  if (typeof props.onNavigatePanoramic === 'function') {
                    props.onNavigatePanoramic('ventas');
                  }
                  navigate(`/ad_venta/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/-`);
                  handleClick('icono02-1');
                  }}
                />
                <SubMenuItem
                  icon={<BadgeIcon />}
                  label="Clientes"
                  isActive={selectedButton === 'icono02-4'}
                  onClick={() => {
                    navigate(`/ad_correntistahabitual/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                    handleClick('icono02-4');
                  }}
                />
                <SubMenuItem
                  icon={<TableRowsIcon />}
                  label="Detalle"
                  watermarkIcon={<InsertChartIcon />}
                  isActive={selectedButton === 'icono02-2'}
                  onClick={() => {
                    navigate(`/ad_ventarepdet/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                    handleClick('icono02-2');
                  }}
                />
                <SubMenuItem
                  icon={<AccountTreeIcon />}
                  label="Ventas Ref."
                  watermarkIcon={<InsertChartIcon />}
                  isActive={selectedButton === 'icono02-3'}
                  onClick={() => {
                    navigate(`/ad_ventarepref/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                    handleClick('icono02-3');
                  }}
                />
                <SubMenuItem
                  icon={renderSunatMenuIcon(selectedButton === 'icono02-5')}
                  label="RDI SUNAT"
                  isActive={selectedButton === 'icono02-5'}
                  onClick={() => {
                    navigate(`/ad_ventaresumensunat/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                    handleClick('icono02-5');
                  }}
                />
              </List>
            </Collapse>
          </>
        )}

        {accesoAdmin && esRubroTransporte && (
          <>
            <MenuItem
              icon={<SummarizeIcon />}
              label="Operaciones"
              menuId="transporte"
              onClick={handleTransportesClick}
              hasSubmenu={true}
              isSubmenuOpen={openTransportes}
            />
            <Collapse in={openTransportes} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {puedeMenuTransporte('transporte.dashboard') && (
                  <SubMenuItem
                    icon={<DashboardCustomizeIcon />}
                    label="Dashboard"
                    menuId="transporte.dashboard"
                    isActive={selectedButton === 'icono11-0'}
                    onClick={() => {
                      navigate(`/ad_transportedashboard/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                      handleClick('icono11-0');
                    }}
                  />
                )}
                {puedeMenuTransporte('transporte.encomiendas') && (
                  <SubMenuItem
                    icon={<Inventory2Icon />}
                    label="Encomiendas"
                    menuId="transporte.encomiendas"
                    iconTone="encomiendas"
                    isActive={selectedButton === 'icono11-1'}
                    onClick={() => {
                      if (typeof props.onNavigatePanoramic === 'function') {
                        props.onNavigatePanoramic('encomiendas');
                      }
                      navigate(`/ad_transportesencomienda/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                      handleClick('icono11-1');
                    }}
                  />
                )}
                {puedeMenuTransporte('transporte.grem') && (
                  <SubMenuItem
                    icon={<GremDocumentIcon />}
                    label="GREM"
                    menuId="transporte.grem"
                    isActive={selectedButton === 'icono11-grem'}
                    onClick={() => {
                      if (typeof props.onNavigatePanoramic === 'function') {
                        props.onNavigatePanoramic('grem');
                      }
                      navigate(`/ad_transportegrem/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                      handleClick('icono11-grem');
                    }}
                  />
                )}
                {puedeMenuTransporte('transporte.entregas') && (
                  <SubMenuItem
                    icon={<AssignmentTurnedInIcon />}
                    label="Entregas"
                    menuId="transporte.entregas"
                    iconTone="entregas"
                    isActive={selectedButton === 'icono11-8'}
                    onClick={() => {
                      if (typeof props.onNavigatePanoramic === 'function') {
                        props.onNavigatePanoramic('entregas');
                      }
                      navigate(`/ad_transporteentregas/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                      handleClick('icono11-8');
                    }}
                  />
                )}
                {puedeMenuTransporte('transporte.caja') && (
                  <SubMenuItem
                    icon={<AccountBalanceWalletIcon />}
                    label="Caja"
                    menuId="transporte.caja"
                    iconTone="caja"
                    isActive={selectedButton === 'icono11-9'}
                    onClick={() => {
                      if (typeof props.onNavigatePanoramic === 'function') {
                        props.onNavigatePanoramic('caja');
                      }
                      navigate(`/ad_transportecaja/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                      handleClick('icono11-9');
                    }}
                  />
                )}
                {puedeMenuTransporte('transporte.boletos') && (
                  <SubMenuItem
                    icon={<MinivanMenuIcon />}
                    label="Boletos"
                    menuId="transporte.boletos"
                    isActive={selectedButton === 'icono11-2'}
                    onClick={() => {
                      if (typeof props.onNavigatePanoramic === 'function') {
                        props.onNavigatePanoramic('boletos');
                      }
                      navigate(`/ad_transportesboletos/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                      handleClick('icono11-2');
                    }}
                  />
                )}
                <SubMenuItem
                  icon={renderSunatMenuIcon(selectedButton === 'icono11-rdi')}
                  label="HISTORIAL RDI y CDR"
                  menuId="transporte.sunat.bajas"
                  isActive={selectedButton === 'icono11-rdi'}
                  onClick={() => {
                    navigate(`/ad_transporterdiencomienda/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                    handleClick('icono11-rdi');
                  }}
                />

              </List>
            </Collapse>
          </>
        )}

        <MenuItem icon={<ReceiptLongIcon />} label="SIRE" onClick={() => setOpenSire(v => !v)} hasSubmenu={true} isSubmenuOpen={openSire} />
        <Collapse in={openSire} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <SubMenuItem
              icon={<ReceiptLongIcon />}
              label="Ventas"
              menuId="transporte.sunat.rdi"
              isActive={selectedButton === 'icono11-sire'}
              onClick={() => {
                navigate(`/ad_transportesire/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                handleClick('icono11-sire');
              }}
            />
            <SubMenuItem icon={<ReceiptLongIcon />} label="Compras" isActive={selectedButton === 'sire-compras'} onClick={() => {
              navigate(`/sire/compras/${[props.idAnfitrion, props.idInvitado, periodo_trabajo || '-', contabilidad_trabajo || '-'].map(encodeURIComponent).join('/')}`);
              handleClick('sire-compras');
            }} />
          </List>
        </Collapse>

        {accesoAdmin && esRubroProyectos && (
          <MenuItem
            icon={<CropFreeIcon />}
            label="Proyectos y Servicios"
            isActive={selectedButton === 'icono02-4'}
            onClick={() => {
              if (typeof props.onNavigatePanoramic === 'function') {
                props.onNavigatePanoramic('presupuestos');
              }
              navigate(`/ad_ventapresupuesto/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
              handleClick('icono02-4');
            }}
          />
        )}

        {accesoAdmin && (!esRubroTransporte || puedeMenuTransporte('transporte.puntos')) && (
          <MenuItem
            icon={<HolidayVillageIcon />}
            label={etiquetaPuntosVenta}
            menuId={esRubroTransporte ? "transporte.puntos" : undefined}
            isActive={selectedButton === 'icono11-3'}
            onClick={() => {
              navigate(`/ad_puntoventa/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
              handleClick('icono11-3');
            }}
          />
        )}

        {accesoAdmin && esRubroTransporte && (
          <>
            {puedeMenuTransporte('transporte.rutas') && (
              <MenuItem
                icon={<CompareArrowsIcon />}
                label="Rutas"
                menuId="transporte.rutas"
                isActive={selectedButton === 'icono11-4'}
                onClick={() => {
                  navigate(`/ad_transporterutas/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                  handleClick('icono11-4');
                }}
              />
            )}
            {puedeMenuTransporte('transporte.placas') && (
              <MenuItem
                icon={<DirectionsBusIcon />}
                label="Placas"
                menuId="transporte.placas"
                isActive={selectedButton === 'icono11-5'}
                onClick={() => {
                  navigate(`/ad_transporteplacas/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                  handleClick('icono11-5');
                }}
              />
            )}
            {puedeMenuTransporte('transporte.licencias') && (
              <MenuItem
                icon={<BadgeIcon />}
                label="Licencias"
                menuId="transporte.licencias"
                isActive={selectedButton === 'icono11-6'}
                onClick={() => {
                  navigate(`/ad_transportelicencias/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                  handleClick('icono11-6');
                }}
              />
            )}
            {puedeMenuTransporte('transporte.zonas') && (
              <MenuItem
                icon={<HolidayVillageIcon />}
                label="Zonas"
                menuId="transporte.zonas"
                isActive={selectedButton === 'icono11-7'}
                onClick={() => {
                  navigate(`/ad_transportezonas/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                  handleClick('icono11-7');
                }}
              />
            )}
          </>
        )}

        {accesoAdmin && (!esRubroTransporte || puedeMenuTransporte('transporte.usuarios_turnos')) && (
          <MenuItem
            icon={<SystemSecurityUpdateGoodIcon />}
            label="Usuarios turnos"
            menuId={esRubroTransporte ? "transporte.usuarios_turnos" : undefined}
            isActive={selectedButton === 'icono11'}
            onClick={() => {
              navigate(`/ad_puntoventausuario/${props.idAnfitrion}/${props.idInvitado}`);
              handleClick('icono11');
            }}
          />
        )}

        {puedeConfigurarMenus && (
          <>
            <MenuItem
              icon={<TableRowsIcon />}
              label="Menu config"
              isActive={selectedButton === 'icono-menu-config'}
              onClick={() => {
                navigate(`/ad_menuconfig/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                handleClick('icono-menu-config');
              }}
            />
            <MenuItem
              icon={<SecurityIcon />}
              label="Menu permisos"
              isActive={selectedButton === 'icono-menu-permisos'}
              onClick={() => {
                navigate(`/ad_menupermisos/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                handleClick('icono-menu-permisos');
              }}
            />
          </>
        )}

        {accesoAdmin && (esRubroComercial || esRubroProyectos) && (
          <MenuItem
            icon={<QrCodeIcon />}
            label="Productos"
            isActive={selectedButton === 'icono03'}
            onClick={() => {
              navigate(`/ad_producto/${props.idAnfitrion}/${props.idInvitado}/${contabilidad_trabajo}`);
              handleClick('icono03');
            }}
          />
        )}

        {gruposSkuHabilitados && (
          <MenuItem
            icon={<QrCodeIcon />}
            label="Grupos Color"
            isActive={selectedButton === 'icono-producto-grupo'}
            onClick={() => {
              navigate(`/ad_productogrupo/${props.idAnfitrion}/${props.idInvitado}/${contabilidad_trabajo}`);
              handleClick('icono-producto-grupo');
            }}
          />
        )}

        {accesoAdmin && esRubroComercial && (
          <>
            <MenuItem
              icon={<HolidayVillageIcon />}
              label="Stocks"
              isActive={selectedButton === 'icono10'}
              onClick={handleStocksClick}
              hasSubmenu={true}
              isSubmenuOpen={openStocks}
            />
            <Collapse in={openStocks} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <SubMenuItem
                  icon={<QrCodeIcon />}
                  label="Movimientos"
                  isActive={selectedButton === 'icono10-1'}
                  onClick={() => {
                    //navigate(`/ad_stock/${props.idAnfitrion}/${props.idInvitado}/${contabilidad_trabajo}`);
                    navigate(`/ad_stock/${props.idAnfitrion}/${props.idInvitado}/-`);
                    handleClick('icono10-1');
                  }}
                />
                <SubMenuItem
                  icon={<CompareArrowsIcon />}
                  label="Detalle"
                  watermarkIcon={<InsertChartIcon />}
                  isActive={selectedButton === 'icono10-2'}
                  onClick={() => {
                    navigate(`/ad_stockrepdet/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                    handleClick('icono10-2');
                  }}
                />
                <SubMenuItem
                  icon={<SummarizeIcon />}
                  label="Inventarios Kardex"
                  watermarkIcon={<InsertChartIcon />}
                  isActive={selectedButton === 'icono10-3'}
                  onClick={() => {
                    navigate(`/ad_stockrepinventario/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                    handleClick('icono10-3');
                  }}
                />
              </List>
            </Collapse>
          </>
        )}

        {esRubroContable && tieneOpcionesContables && (
          <>
            <Divider sx={{ marginY: 0.7, borderColor: 'transparent' }} />
            <MenuItem
              icon={<GradingIcon />}
              label="Contable"
              onClick={handleContableClick}
              hasSubmenu={true}
              isSubmenuOpen={openContable}
            />
            <Collapse in={openContable} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {(permisoVentas || permisoCompras || permisoCaja || permisoDiario) && (
                  <SubMenuItem
                    icon={<GradingIcon />}
                    label="Asientos"
                    isActive={selectedButton === 'icono04'}
                    onClick={() => {
                      navigate(`/asiento/${props.idAnfitrion}/${props.idInvitado}/${periodo_trabajo}/${contabilidad_trabajo}`);
                      handleClick('icono04');
                    }}
                  />
                )}

                {permisoReportes && (
                  <SubMenuItem
                    icon={<InsertChartIcon />}
                    label="Reportes"
                    isActive={selectedButton === 'icono05'}
                    onClick={() => {
                      navigate(`/reporte/${props.idAnfitrion}/${props.idInvitado}`);
                      handleClick('icono05');
                    }}
                  />
                )}

                {permisoContabilidades && (
                  <SubMenuItem
                    icon={<NextWeekIcon />}
                    label="Contabilidades"
                    isActive={selectedButton === 'icono06'}
                    onClick={() => {
                      navigate(`/contabilidades/${props.idAnfitrion}/${props.idInvitado}`);
                      handleClick('icono06');
                    }}
                  />
                )}

                {permisoTipoCambio && (
                  <SubMenuItem
                    icon={<PaidIcon />}
                    label="Tipo Cambio"
                    isActive={selectedButton === 'icono07'}
                    onClick={() => {
                      navigate(`/correntista`);
                      handleClick('icono07');
                    }}
                  />
                )}

                {permisoCentroCosto && (
                  <SubMenuItem
                    icon={<CenterFocusStrongIcon />}
                    label="Centro Costos"
                    isActive={selectedButton === 'icono08'}
                    onClick={() => {
                      navigate(`/ad_equipo/${props.idAnfitrion}/${props.idInvitado}/${contabilidad_trabajo}`);
                      handleClick('icono08');
                    }}
                  />
                )}

              </List>
            </Collapse>
          </>
        )}

        {permisoSeguridad && (
          <>
            <Divider sx={{ marginY: 0.7, borderColor: 'transparent' }} />
            <MenuItem
              icon={<SystemSecurityUpdateGoodIcon />}
              label="Seguridad"
              isActive={selectedButton === 'icono09'}
              onClick={() => {
                navigate(`/seguridad/${props.idAnfitrion}`);
                handleClick('icono09');
              }}
            />
          </>
        )}
      </List>
    </Box>
  );

  return (
    <>
      {isMobile && (
        <Fab
          aria-label="menu"
          onClick={handleDrawerToggle}
          sx={{
            position: 'fixed',
            top: 16,
            left: 16,
            zIndex: 1300,
            boxShadow: 3,
            backgroundColor: sidebarColors.accent,
            color: sidebarColors.onAccent,
            '&:hover': {
              backgroundColor: sidebarColors.accent,
              color: sidebarColors.onAccent,
            },
          }}
        >
          <MenuIcon />
        </Fab>
      )}

      {!isMobile && (
        <Drawer
          variant="permanent"
          sx={{
            width: isExpanded && !panoramicMode ? drawerWidthExpanded : drawerWidthCollapsed,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
              width: isExpanded && !panoramicMode ? drawerWidthExpanded : drawerWidthCollapsed,
              boxSizing: 'border-box',
              transition: 'width 0.3s ease',
              overflowX: 'hidden',
              overflowY: 'hidden',
              border: 'none',
              borderRight: 'none',
              backgroundColor: sidebarColors.bg,
              background: sidebarColors.bg,
              top: 16,
              left: 16,
              height: 'calc(100vh - 32px)',
              borderRadius: 3,
              boxShadow: palette.shadowSoft,
            },
          }}
        >
          {drawerContent}
        </Drawer>
      )}

      {isMobile && (
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            '& .MuiDrawer-paper': {
              width: drawerWidthExpanded,
              boxSizing: 'border-box',
              border: 'none',
              borderRight: 'none',
              backgroundColor: sidebarColors.bg,
              background: sidebarColors.bg,
              borderRadius: '0 12px 12px 0',
            },
          }}
        >
          {drawerContent}
        </Drawer>
      )}
    </>
  );
}
